import permissionsRegistry from "./data/permissions.json" with { type: "json" };
import featuresArray from "./data/features.json" with { type: "json" };
import productFeaturesMap from "./data/product-features.json" with { type: "json" };
export { productFeaturesMap };
const fulfilmentFeatures = new Set(featuresArray);
export function getFeatureForPermission(permission) {
    const def = permissionsRegistry[permission];
    return def?.feature ?? null;
}
export function hasPermission(actor, permission) {
    return actor.permissions.includes(permission);
}
export function hasFeature(actor, feature) {
    return actor.firmFeatures.includes(feature);
}
export function isEntitled(actor, permission) {
    if (!hasPermission(actor, permission)) {
        return false;
    }
    const feature = getFeatureForPermission(permission);
    if (feature !== null && fulfilmentFeatures.has(feature)) {
        return hasFeature(actor, feature);
    }
    return true;
}
export function computeAvailablePermissions(firmFeatures) {
    const firmFeatureSet = new Set(firmFeatures);
    const available = new Set();
    for (const [permission, def] of Object.entries(permissionsRegistry)) {
        if (def.feature === null || firmFeatureSet.has(def.feature)) {
            available.add(permission);
        }
    }
    return available;
}
export function projectEntitlementToFeatures(metadata) {
    const seen = new Set();
    for (const permission of metadata.permissions) {
        const featureCode = productFeaturesMap[permission.product];
        if (featureCode !== null && featureCode !== undefined) {
            seen.add(featureCode);
        }
    }
    return Array.from(seen);
}
export const BASELINE_FEATURES = ["profiles", "nominations"];
export function resolveFirmFeatures(metadata, overrides = []) {
    const base = projectEntitlementToFeatures(metadata);
    return Array.from(new Set([...base, ...BASELINE_FEATURES, ...overrides]));
}
//# sourceMappingURL=helpers.js.map